import React from "react";

const IArrowBack = ({width = 18, height = 18, color = "#252526", ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M15.75 9.00031C15.75 9.1495 15.6907 9.29257 15.5852 9.39806C15.4798 9.50355 15.3367 9.56281 15.1875 9.56281H4.17023L8.27297 13.6648C8.32523 13.7171 8.36669 13.7792 8.39497 13.8474C8.42326 13.9157 8.43781 13.9889 8.43781 14.0628C8.43781 14.1367 8.42326 14.2099 8.39497 14.2782C8.36669 14.3465 8.32523 14.4085 8.27297 14.4608C8.22071 14.513 8.15866 14.5545 8.09038 14.5828C8.0221 14.6111 7.94891 14.6256 7.875 14.6256C7.80109 14.6256 7.7279 14.6111 7.65962 14.5828C7.59134 14.5545 7.52929 14.513 7.47703 14.4608L2.41453 9.39828C2.36223 9.34604 2.32074 9.284 2.29244 9.21572C2.26413 9.14743 2.24956 9.07423 2.24956 9.00031C2.24956 8.92639 2.26413 8.8532 2.29244 8.78491C2.32074 8.71662 2.36223 8.65458 2.41453 8.60234L7.47703 3.53984C7.58258 3.4343 7.72573 3.375 7.875 3.375C8.02427 3.375 8.16742 3.4343 8.27297 3.53984C8.37852 3.64539 8.43781 3.78855 8.43781 3.93781C8.43781 4.08708 8.37852 4.23023 8.27297 4.33578L4.17023 8.43781H15.1875C15.3367 8.43781 15.4798 8.49708 15.5852 8.60257C15.6907 8.70805 15.75 8.85113 15.75 9.00031Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowBack;
